import React, { FC, useMemo } from 'react';
import Stack from '@mui/material/Stack';
import { SearchBar } from 'src/components/AutoSearch/AutoSearch';
import { useTranslate } from '@im/react-localization';

export interface SearchFilterProps {
  filter: {
    field: string;
    value: string;
  };
  onChange: (x: any) => void;
  options: {
    label: string;
    value: string;
  }[];
}

const SearchFilter: FC<SearchFilterProps> = ({ filter, onChange, options }) => {
  const translate = useTranslate();
  const placeholder = useMemo(
    () =>
      translate('CustomerGroups.filterPlaceholder', {
        field: options.find(({ value }) => value === filter?.field)?.label,
      }),
    [options, filter.field, translate]
  );

  function handleQueryChange({ inputValue: value }: any) {
    onChange({
      ...filter,
      value,
    });
  }

  function handleFieldChange({ value: field }: any) {
    onChange({
      ...filter,
      field,
    });
  }

  function handleClear() {
    onChange({
      ...filter,
      value: '',
    });
  }

  return (
    <Stack direction="row">
      <SearchBar
        dropdownOptions={options}
        onClearClick={handleClear}
        onDropdownOptionChange={handleFieldChange}
        onSearch={handleQueryChange}
        placeholder={placeholder}
        sx={{ maxWidth: '442px' }}
        value={filter.value}
      />
    </Stack>
  );
};

export default SearchFilter;
